import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { registerRichText } from '@lexical/rich-text';
import { useEffect } from 'react';

/**
 * Registers rich text editing behaviour, in place of `RichTextPlugin`.
 *
 * `RichTextPlugin` is `registerRichText` and `registerDragonSupport`, plus a
 * `Placeholder` and `LegacyDecorators`. Only the first is wanted here.
 *
 * The `Placeholder`, which Lexical itself marks `// TODO remove`, resolves "can
 * show placeholder" into React state that settles after mount, driven by a
 * Lexical listener. Consumers cannot wrap that in `act()`, so it surfaces as
 * "An update to Placeholder inside a test was not wrapped in act(...)" and
 * `jest-fail-on-console` fails every test that renders a textarea. RawTextarea
 * renders its own placeholder from the controlled value instead, which needs no
 * async state.
 *
 * `LegacyDecorators` only renders DecoratorNodes, and none of the nodes this
 * editor is configured with is one.
 *
 * `registerDragonSupport` handles dictation from Dragon NaturallySpeaking's
 * browser extension, which the product does not support, so it is left out.
 * Nothing depends on its absence — if dictation is ever wanted, registering it
 * alongside `registerRichText` is what enables it.
 */
export const RawTextareaRichTextPlugin = () => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => registerRichText(editor), [editor]);

  return null;
};
